import useService from "../../../../hooks/useService";

export default function useSettlementPermissions() {
  const currentUserService = useService("current-user-service");
  const permissions = currentUserService?.userRoles?.permissions ?? [];

  return {
    permissions,
    canEditCaseSettlement: permissions.includes("casemanager.change_case"),
    canViewMedicalBreakdown: permissions.includes("provider.view_providersettlement"),
    canEditMedicalBreakdown: permissions.includes("provider.change_providersettlement"),
    canViewPayments: permissions.includes("casemanager.view_settlementcheck"),
    canAddPayments: permissions.includes("casemanager.add_settlementcheck"),
    canEditPayments: permissions.includes("casemanager.change_settlementcheck"),
    canViewOtherLiensBalance: permissions.includes("provider.view_additionalexpense"),
    canAddOtherLiensBalance: permissions.includes("provider.add_additionalexpense"),
    canEditOtherLiensBalance: permissions.includes("provider.change_additionalexpense"),
    canDeleteOtherLiensBalance: permissions.includes("provider.delete_additionalexpense"),
  };
}
